import React from 'react';
export function BonusesSection() {
  const bonuses = [{
    num: '01',
    title: 'Kit "Arrancá Mañana" — Clases Express en 10 min',
    desc: '24 guiones de clase listos (12 primaria + 12 secundaria) para cuando no tenés nada preparado',
    val: '$12.000'
  }, {
    num: '02',
    title: 'Banco "Consignas Infalibles"',
    desc: '300 consignas listas por nivel (primaria + secundaria) para que el curso arranque sin caos',
    val: '$10.000'
  }, {
    num: '03',
    title: 'Rúbricas & Evidencias "Corrección Sin Agotarte"',
    desc: '24 rúbricas listas + 20 evidencias rápidas para corregir más rápido y con criterios claros',
    val: '$9.000'
  }, {
    num: '04',
    title: 'Pack "Errores Típicos" — Diagnóstico + Intervenciones',
    desc: '60 tarjetas de error (primaria + secundaria) para destrabar en el momento sin repetir mil veces',
    val: '$8.000'
  }, {
    num: '05',
    title: 'Plantillas "Pizarra & Slides Pro"',
    desc: '50 plantillas de explicaciones visuales para que tus clases se vean claras y ordenadas',
    val: '$7.000'
  }, {
    num: '06',
    title: 'Calendario "Año Matemática Bajo Control"',
    desc: 'Rutinas semanales + checkpoints + trackers para no llegar corriendo a cada cierre',
    val: '$9.000'
  }];
  return <section className="bg-brand-dark py-24 px-4 border-t border-brand-border pt-[40px] pb-[40px]" data-id="element-15">
      <div className="max-w-5xl mx-auto" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-4" data-id="element-18">
            Más los 6 Bonos{' '}
            <span className="text-brand-accent" data-id="element-19">Estratégicos</span>
          </h2>
          <p className="text-lg text-white/70 font-medium" data-id="element-20">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-16" data-id="element-21">
          {bonuses.map((bonus, i) => <div key={i} className="bg-brand-card rounded-2xl p-6 border border-brand-border relative overflow-hidden" data-id="element-22">
              <div className="text-6xl font-heading font-black text-brand-accent/20 absolute top-3 right-4 leading-none" aria-hidden="true" data-id="element-23">
                {bonus.num}
              </div>
              <div className="relative z-10" data-id="element-24">
                <div className="text-brand-accent font-badge font-black text-sm tracking-widest uppercase mb-4" data-id="element-25">
                  BONO {bonus.num}
                </div>
                <h3 className="text-xl font-heading font-bold text-white mb-3 pr-10 leading-tight" data-id="element-26">
                  {bonus.title}
                </h3>
                <p className="text-white/70 mb-6 text-sm leading-relaxed" data-id="element-27">
                  {bonus.desc}
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-brand-border" data-id="element-28">
                  <div className="text-white/60 line-through text-sm" data-id="element-29">
                    Valor {bonus.val}
                  </div>
                  <div className="text-brand-dark font-black text-sm bg-brand-accent px-4 py-1 rounded-full uppercase tracking-wider" data-id="element-30">
                    GRATIS
                  </div>
                </div>
              </div>
            </div>)}
        </div>
        <div className="bg-brand-accent/5 rounded-2xl p-8 text-center border border-brand-accent/20 max-w-2xl mx-auto" data-id="element-31">
          <h3 className="text-xl font-heading font-bold text-brand-accent mb-2" data-id="element-32">
            🎁 Valor total de los 6 Bonos $55.000 → GRATIS — Solo por hoy
          </h3>
          <p className="text-white/70 font-medium" data-id="element-33">
            Incluidos en las 3 ofertas. Siempre.
          </p>
        </div>
      </div>
    </section>;
}